import { Box, Typography } from "@mui/material";
import SourceIcon from "./sourceIcon";

const ChangeStatus = ({ log }) => {
  return (
    <Box dir="rtl">
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start", // Changed for RTL
          alignItems: "flex-start",
        }}
      >
        {/* Status Text */}
        {log.details.prevStatus ? (
          <Typography
            variant="body1"
            sx={{ textAlign: "right", whiteSpace: "nowrap" }}
          >
            סטטוס עודכן מ: {String(log.details.prevStatus)} ל:{" "}
            <strong>{log.details.status}</strong>
          </Typography>
        ) : (
          <Typography
            variant="body1"
            sx={{ textAlign: "right", whiteSpace: "nowrap" }}
          >
            סטטוס אותחל ב: <strong>{log.details.status}</strong>
          </Typography>
        )}

        {/* Icon */}
        <Box sx={{ ml: 2 }}>
          {" "}
          {/* Changed from mr to ml */}
          <SourceIcon source={log.source} />
        </Box>
      </Box>

      {/* Description */}
      {log.details.description && (
        <Box sx={{ mt: 1, pr: 2 }}>
          {" "}
          <Typography
            variant="body2"
            sx={{
              textAlign: "right",
              display: "flex",
              justifyContent: "flex-start", // Will align to right in RTL
            }}
          >
            {log.details.description}
          </Typography>
        </Box>
      )}
      <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-start" }}>
        <Typography variant="body2" sx={{ direction: "rtl" }}>
          {log.details.userLogin} :על ידי
        </Typography>
      </Box>
    </Box>
  );
};

export default ChangeStatus;
